module.exports = __webpack_public_path__ + "static/media/souse_spices.983ba655.png";